export function groupByKey<T>(
    items: T[],
    keyFn: (item: T) => string,
): Map<string, T[]> {
    const map = new Map<string, T[]>();
    for (const item of items) {
        const key = keyFn(item);
        const group = map.get(key) ?? [];
        group.push(item);
        map.set(key, group);
    }
    return map;
}
